import React, { useState } from 'react';
import { toFilterString } from '../../../util/string.util';
import { BaseFilter } from '../../../VentoryUI/components/filters/common/BaseFilter';
import { Searchbar } from '../TextInput';
import Filter from './Filter';

interface SearchFilterProps<T> {
  filter: BaseFilter<T>;
  items: T[];
  setItems: (items: T[]) => void;
  loading?: boolean;
  placeholder?: string;
}

export default function SearchFilter<T>({ filter, items, setItems, loading, placeholder }: SearchFilterProps<T>) {
  const [query, setQuery] = useState<string>('');

  return (
    <div className='flex items-center gap-2'>
      <Searchbar value={query} onChange={value => setQuery(value)} placeholder={placeholder} clearable />
      <Filter
        items={items}
        setItems={setItems}
        query={toFilterString(query)}
        setQuery={setQuery}
        filter={filter}
        loading={loading}
      />
    </div>
  );
}
